module.exports = __webpack_public_path__ + "static/media/Tien.027cbc19.jpg";